// client/src/components/WhatsAppButton.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Fab, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useStore } from '../context/StoreContext';

// WhatsApp needs the full international number: 082 123 4567 becomes 27821234567.
export const whatsappLink = (number, storeName) => {
  const digits = String(number).replace(/\D/g, '');
  const international = digits.startsWith('0') ? `27${digits.slice(1)}` : digits;
  const message = encodeURIComponent(`Hi ${storeName}, I have a question.`);
  return `https://wa.me/${international}?text=${message}`;
};

const WhatsAppButton = () => {
  const { store } = useStore();
  const { pathname } = useLocation();
  if (!store.whatsapp_number) return null;
  // The admin panel doesn't need it, and on these pages it would cover the buttons.
  if (['/admin', '/checkout', '/documents'].some((path) => pathname.startsWith(path))) return null;
  // Phones have a fixed "Add to Cart" bar along the bottom of product pages.
  const onProduct = pathname.startsWith('/products/');

  return (
    <Tooltip title="Chat on WhatsApp" placement="left">
      <Fab
        component="a"
        href={whatsappLink(store.whatsapp_number, store.name)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="no-print"
        sx={{
          position: 'fixed', right: 16, bottom: { xs: onProduct ? 84 : 16, md: 24 }, zIndex: 1050,
          bgcolor: '#128C4A', color: '#fff', borderRadius: '50% !important', '&:hover': { bgcolor: '#0E7039' },
        }}
      >
        <WhatsAppIcon />
      </Fab>
    </Tooltip>
  );
};

export default WhatsAppButton;
